import { DataDesc } from 'wax-lib';

interface MobileDeviceItem {
    GUID: string | null;
    IMEI: string | '';
    SERIAL: string | null;
    MACADDR: string | null;
    MANUFACTURER: string | null;
    MODEL: string | null;
    TYPE: string | null;
    OSNAME: string | null;
    OSVERSION: string | null;
    LASTUSERID: string | null;
    STATE: number | 0;
    VALIDUNTIL: Date | 0;
    ITK_STATE: string | null;
    ITK_STYLE: string | null;
    CAN_UPDATE: boolean | false;
    CAN_DELETE: boolean | false;
}

export class MobileDeviceDesc extends DataDesc {
    constructor(config: string, entity?: string, primaryKey?: string) {
        super(config, entity, primaryKey);
        this.defaultItem.GUID = null;
        this.defaultItem.IMEI = '';
        this.defaultItem.SERIAL = null;
        this.defaultItem.MACADDR = null;
        this.defaultItem.MANUFACTURER = null;
        this.defaultItem.MODEL = null;
        this.defaultItem.TYPE = null;
        this.defaultItem.OSNAME = null;
        this.defaultItem.OSVERSION = null;
        this.defaultItem.LASTUSERID = null;
        this.defaultItem.STATE = 0;
        this.defaultItem.VALIDUNTIL = 0;
        this.defaultItem.ITK_STATE = '';
        this.defaultItem.ITK_STYLE = null;
        this.defaultItem.CAN_UPDATE = false;
        this.defaultItem.CAN_DELETE = false;
    }

    private get defaultItem() {
        return this.default as MobileDeviceItem;
    }

    private get currentItem() {
        return this.record as MobileDeviceItem;
    }

    public get recordDesc() {
        // super() intentionally not called
        return this.currentItem.IMEI;
    }
}
